// @ts-expect-error: Snowplow types are not defined within the package yet
import { trackSelfDescribingEvent } from '@condenast/cn-snowplow-web';

export const spUserNavigation = (
  ids: string[],
  targetStage?: Record<string, string>,
) => {
  trackSelfDescribingEvent({
    event: {
      schema: 'iglu:com.condenast/navigation_event/jsonschema/3-0-0',
      data: {
        type: 'continue',
        subject_id: targetStage?.id,
        subject: String(targetStage?.name).toLowerCase().replace(/\s/g, '_'),
        label: '',
        items: ids.map((content_id) => ({ content_id })),
      },
    },
  });
};
